module.exports = __webpack_public_path__ + "static/img/pic3.b9cc7e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slideShow/pic3.jpg
// module id = qddZ
// module chunks = 0